// extracted by mini-css-extract-plugin
module.exports = {"koa_table_container":"seguimientoInicialKoaForm_koa_table_container__3bH2S"};